module.exports = __webpack_public_path__ + "img/chevron-up-outline.12ec15e3.png";